import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RCPdf.css";

const RCPdf = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [rcno, setRcno] = useState("");
  const [cardType, setCardType] = useState("2");
  const [chipType, setChipType] = useState("2");
  const [loading, setLoading] = useState(false);

  const handleRCSearch = async () => {
    if (!rcno) {
      alert("Please Enter RC Number");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/rc_process.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          rcno,
          cardType,
          chipType
        }),
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "wallet_low") {
        alert("Wallet Low! Please Recharge");
      } 
      else if (data.status === "failed") {
        alert(data.message || "RC Failed");
      } 
      else if (data.status === "success") {
        alert("RC Generated Successfully 🎉");
        navigate("/dashboard/rcpdflist");
      }

    } catch (err) {
      console.log(err);
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div className="rc-outer">

      {/* ===== Loading Overlay ===== */}
      {loading && (
        <div className="rc-loading">
          <div className="load-box">
            <div className="spinner"></div>
            <p className="load-text">Processing your request...</p>
          </div>
        </div>
      )}

      {/* MAIN PREMIUM CARD */}
      <div className="rc-card">

        <h2 className="rc-title">RC PDF Generator</h2>
        <p className="rc-sub">Instant Smart Card RC PDF</p>

        <div className="price-tag">
          ₹99 / Search
        </div>

        <input
          type="text"
          placeholder="Enter RC Number"
          value={rcno}
          onChange={(e) => setRcno(e.target.value.toUpperCase())}
          className="rc-input-new"
        />

        <select
          value={cardType}
          onChange={(e) => setCardType(e.target.value)}
          className="rc-input-new"
        >
          <option value="1">Old Background</option>
          <option value="2">New Background</option>
        </select>

        <select
          value={chipType}
          onChange={(e) => setChipType(e.target.value)}
          className="rc-input-new"
        >
          <option value="1">Chip</option>
          <option value="2">Non-Chip</option>
        </select>

        <div className="rc-btn-row">
          <button onClick={handleRCSearch} className="rc-main-btn">
            {loading ? "Processing..." : "Get RC PDF"}
          </button>

          <a 
            href="https://rcfinder.online/sample/samplerc.pdf"  // <-- yaha apna sample pdf link daal dena
            target="_blank"
            className="rc-sample-btn"
          >
            View Sample
          </a>
        </div>

      </div>

    </div>
  );
};

export default RCPdf;
